import { DropdownModel } from '@shared/models/dropdown-model.model';
import { Expose, Type } from 'class-transformer';
import { User } from '../../users/models/user.model';

export class ProductType extends DropdownModel {
  @Expose() id: number;
  @Expose() name?: string = '';
  @Expose() customerId?: number;
  @Expose() productTypeId?: number;
  @Expose() isDefault?: boolean = false;
  @Expose()
  @Type(() => User)
  createdBy?: User = new User();
  @Expose()
  @Type(() => User)
  updatedBy?: User = new User();
  @Expose() createdAt?: number;
  @Expose() updatedAt?: number;
  @Expose()
  createdByCustomer?: number;

  @Expose() productItemCount?: number;

  constructor() {
    super();
  }

  get dropDownDisplayName(): string {
    return this.name;
  }
  get dropDownValue(): Object {
    return this;
  }
}
